"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeoutManager = void 0;
var TimeoutManager = /** @class */function () {
  function TimeoutManager() {
    this._timers = {};
  }
  TimeoutManager.prototype.setTimeout = function (key) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    this.clearTimeout(key);
    this._timers[key] = window.setTimeout.apply(null, args);
    return this._timers[key];
  };
  TimeoutManager.prototype.clearTimeout = function (key) {
    var timerHandle = this._timers[key];
    if (timerHandle) {
      window.clearTimeout(timerHandle);
    }
  };
  TimeoutManager.prototype.clearAllTimeouts = function () {
    var _this = this;
    Object.keys(this._timers).forEach(function (key) {
      return _this.clearTimeout(key);
    });
  };
  return TimeoutManager;
}();
exports.TimeoutManager = TimeoutManager;